// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1g9n3","col":"Table_col__1H9c0","fulfillmentStatus":"Table_fulfillmentStatus__2Ffbg","emailCol":"Table_emailCol__q49Xf"};